<template>
	<div class="loader__error">
		<slot />
	</div>
</template>

<script>
	export default {
		/**
		 * Name
		 */
		name: 'LoaderError',
	}
</script>

